import moment from 'moment'
import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Execution } from '../models/execution.entity'

export type ExecutionNotificationCode =
  | GenericNotificationCode
  | 'EXECUTION_DELETED'

export type ExecutionModalCode = 'EXECUTION_DELETION'

/**
 * Parse goods return code to a notification
 * @param code - the goods return notification code
 * @returns the notification options
 */
export function parseExecutionNotification(
  code?: ExecutionNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'EXECUTION_DELETED':
      return {
        message: 'Execution deleted successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse goods return code to an modal
 * @param code - the goods return modal code
 * @param execution - the goods return object
 * @returns the modal settings
 */
export function parseExecutionModal(
  code: ExecutionModalCode,
  execution?: Execution,
): DialogOptions {
  switch (code) {
    case 'EXECUTION_DELETION': {
      const activityCode = execution?.activity.code
      const activityStart = moment(execution?.createdAt).format('DD/MM/YYYY')
      const params: string[] = []
      if (activityCode) {
        params.push(activityCode)
      }
      if (activityStart) {
        params.push(activityStart)
      }
      return {
        title: 'Delete execution',
        message:
          'You are about to delete the execution <strong>%s</strong> of the <strong>%s</strong>. Proceed with deletion?',
        messageParams: params,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
